import { render, staticRenderFns } from "./syntheticFreeRoomReport.vue?vue&type=template&id=873b2528&scoped=true"
import script from "./syntheticFreeRoomReport.vue?vue&type=script&lang=js"
export * from "./syntheticFreeRoomReport.vue?vue&type=script&lang=js"
import style1 from "./syntheticFreeRoomReport.vue?vue&type=style&index=1&id=873b2528&prod&lang=scss&scoped=true"
import style2 from "./syntheticFreeRoomReport.vue?vue&type=style&index=2&id=873b2528&prod&lang=scss"
import style3 from "./syntheticFreeRoomReport.vue?vue&type=style&index=3&id=873b2528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873b2528",
  null
  
)

export default component.exports